<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'services',
          title: 'Services',
          active: 1,
          image: '',
          color: 'gray-100',
          opacity: '',
          pad_t: '0',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          icon: '',
          icon_color: 'revinre',
          h2: 'A La Carte services',
          h2_color: '',
          h2_desc: 'One of the best parts of the Revinre system is the ability to pick and choose only the services you truly need.',
          h2_desc_color: '',
          pre_btn: [],
          sv_icon_color: 'revinre',
          sv_text_color: 'black',
          post_btn: [],
        },

        loading_services: true,
        services: [],
      }
    },
    computed: {
      used_services: function() {
        var results = [], used = [];
        if(this.packages) { for(var i in this.packages) {
          var services = [];
          if(this.packages[i].services) { for(var j in this.packages[i].services) {
            if(used.includes(this.packages[i].services[j].id)) {
              services.push(this.packages[i].services[j].id);
            } else {
              used.push(this.packages[i].services[j].id);
            }
          } }
          results.push(services);
        } }
        return results;
      },
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }

      if(this.type != 'editor') { this.fetch_services(); }
    },
    methods: {
      fetch_services() {
        this.loading_services = true;
        this.$http.get((this.isAdmin ? '/api' : '')+'/services/fetch', {params: {paginate: 100, page: 1, total: 0, wheres: {status: 1, additional: 1, initial: 1}}}).then(res => {
          // console.log(res);
          this.services = res.data.data;
          this.loading_services = false;
        }).catch(res => {
          this.loading_services = false;
          // this.$noty.warning("There was an error loading the required data. Please try again and contact support if the problem persists.");
        });
      },
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Services :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.sv_icon_color" Title="Icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.sv_text_color" Title="Text color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']" data-aos="fade-zoom-in">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" :class="'text-'+pc['h2_desc_color']" data-aos="fade-zoom-in">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

        <div v-if="loading_services && !services.length" class="row m-0">
          <div v-for="c_i in 12" :key="c_i" class="col-sm-6 col-md-4 p-1 mb" data-aos="fade-zoom-in">
            <div class="row m-0 mb-3">
              <div class="p-0" style="width: 50px;"><div class="ph m-1" style="height: 27px;"></div></div>
              <div class="p-0 col"><div class="ph m-1" style="height: 27px;"></div></div>
            </div>
          </div>
        </div>

        <div v-if="!loading_services && !services.length" class="card text-center p-4 bg-white position-relative mb-4" data-aos="fade-zoom-in">
          <p>No services could be found. This is most likely due to website maintenance. Please check back later or contact us.</p>
        </div>

        <div class="row m-0">
          <div v-for="(serv, serv_i) in services" :key="serv_i" class="col-sm-6 col-md-4 p-1" data-aos="fade-zoom-in" v-tippy :content="serv.description" @show="() => serv.description ? true : false">
            <div class="p-sm-2 h-100">
              <p class="m-0 p-1 font-weight-bold" :class="'text-'+pc['sv_text_color']"><Icon icon="ri:checkbox-line" height="30" class="mr-2" :class="'text-'+pc['sv_icon_color']"></Icon> {{serv.title}} <Icon v-if="serv.description" icon="ri:information-fill" class="text-muted" /> <span class="text-muted">({{formatPrice(serv.price, true, false)}})</span></p>
            </div>
          </div>
        </div>

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center mt-5">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>
